<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="form.pkid > 0 ? '预览':'新建'"
      class="customer-edit"
      width="800px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="form"
        class="form"
        label-width="100px">
      <div>
        <el-form-item label="创建时间" prop="createTime">
          <div style="display: flex;flex-direction: row;">
            <el-input v-model="form.createTime" placeholder="请输入" clearable readonly/>
          </div>
        </el-form-item>
        <el-form-item label="关联单号" prop="techParamList">
          <div style="display: flex;flex-direction: row;">
            <el-input v-model="form.techParamList" placeholder="请输入" clearable readonly/>
          </div>
        </el-form-item>
        <div class="editTitle" style="margin-top:2%">
          订单附件
        </div>
        <el-table border :data="form.accessoryList">
          <el-table-column type="index" align="center" label="#" width="55"/>
          <el-table-column prop="fileName" align="left" label="附件描述" show-overflow-tooltip/>
          <el-table-column label="下载" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" @click="download(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default {
    name: "WKSMenSuoFilePreview",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        form: {},
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.dialogVisible = true;
        if (id > 0) {
          this.getData(id);
        }
      },
      getData(pkid) {
        this.$http
          .get("basic", `WKSMenSuoFiles/${pkid}`)
          .then(resp => {
            console.log(resp);
            this.form = resp;
          });
      },

      //附件下载
      download(row) {
        let data = {
          name: row.fileName,
          uuid: row.filePath,
        };
        this.$http.exportFile("basic", "file/download", data).then(res => {
          console.log(res);
          let blob = new Blob([res.data], {type: "application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
